/* eslint-disable no-underscore-dangle */

import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { Request } from '../lib/Request';
import { enableBatching } from './utils';
import { reducer as data } from './data';
import { reducer as status } from './status';

const rootReducer = enableBatching(
  combineReducers({
    data,
    status,
  }),
);

/* istanbul ignore next */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export function configureStore(initialState, context = { request: Request.of() }) {
  const enhancer = applyMiddleware(thunk.withExtraArgument(context));
  return createStore(rootReducer as any, initialState, composeEnhancers(enhancer));
}
